import { useEffect, useState, useMemo } from 'react';
import axios from "axios";

import * as helpers from "../utils/utils.js"
import { useClientId } from "../context/context.js";

export function useExtras() {
  const clientId = useClientId();

  const retrieveExtras = async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/clients/${clientId}/extras`,
    );
    return response.data;
  };
      
  return {
    retrieveExtras
  };
}
